import { gql } from '@apollo/client';
import { PLAN_FIELDS_FRAGMENT } from './planFieldsFragment.gql';

export const SIMPLR_ACCOUNT_FIELDS_FRAGMENT = gql`
  ${PLAN_FIELDS_FRAGMENT}
  fragment SimplrAccountFields on SimplrAccount {
    objectId: id
    createdAt
    updatedAt
    accountSid
    adminRoleId
    userRoleId
    planId
    planPtr {
      ...PlanFields
    }
    smbName
    accountStatus
    smbContactNumber
    smbContactEmail
    stripeCustomerId
    stripeSubscriptionId
    simplrMasterAccount
    twilioSubAccountSid
    twilioSubAccountAuthToken
    trialEndDate
    smbContactFirstName
    smbContactLastName
    appSid
    hasSalesForce
    currency
    countryCode
    subAccountSid
    subAccountAuthToken
    subAccountStatus
    masterAccountId
    routingAlgorithm
    homepageUrl
    escalateEmail
    algoliaLastSynced
    algoliaIndexName
    useAutoTagging
    trialStartDate
    trialEndBalance
    subscriptionStartDate
    accountBalance
    subscriptionEndDate
    stripeToken
    lastBillDate
    paymentStatus
    useAutoResponse
    legalDocsSigned
    minimumExpertRank
    isSurveyAccount
    accountCredit
    escalateToBusinessChatResponse
    escalateToSpecialistsChatResponse
    EGEAlgorithmNonLiveChatProbability
    EGEAlgorithmLiveChatProbability
    chatAutoResponseOnTake
    invoiceEmailNotification
    invoiceEmail
    useMenuOperator
    forceExpertRank
    escalateImmediately
    deactivateUnassign
    assignToSimplrTempAssigneeOnCreation
    showDashboardAgentsCSATView
    partnerDashboardMfaEnabled
  }
`;
